import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-suguyaku-input',
  templateUrl: './suguyaku-input.component.html',
  styleUrls: ['./suguyaku-input.component.css', '../style/global.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SuguyakuInputComponent),
    },
  ],
})
export class SuguyakuInputComponent implements OnInit {
  @Input()
  placeholder = '';

  @Input()
  name = '';

  inputState = {
    isShow: false,
    isFocus: false,
  };

  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };

  constructor() { }

  private _text = '';
  get text() {
    return this._text;
  }

  @Input()
  set text(val: string) {
    this._text = val;
    this.onChangeCallback(val);
  }

  writeValue(obj: any): void {
    this.text = obj;
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void { }

  ngOnInit(): void { }

  get state() {
    if (this.text?.length || this.inputState?.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  blur() {
    this.inputState.isFocus = false;
  }
  focus() {
    this.inputState.isFocus = true;
  }
}
